"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.limiterResults = void 0;
var limiterResults;
(function (limiterResults) {
    limiterResults["ALLOW"] = "allow";
    limiterResults["DELAY"] = "delay";
    limiterResults["REJECT"] = "reject";
    limiterResults["ABORT"] = "abort";
    limiterResults["TENTATIVE"] = "tentative";
})(limiterResults || (exports.limiterResults = limiterResults = {}));
